const routes = [
    {
        path: "/identity/cards",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'identitycard_index'
        }
    }
];

export default routes;
